export default {
      id: "ic_open_comment-usage",
      viewBox: "0 0 18 17",
      url: "/" + "images/icons.3.109.2.svg#ic_open_comment-usage",
      toString: function () {
        return this.url;
      }
    }